import { useTranslation } from 'react-i18next';

export default function MenuHero() {
  const { t } = useTranslation();

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/dc4ebf47cdb83e0a7e28d2935b7328fe.jpeg"
          alt="Bucara Burger Menu"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/75 to-black/95"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#F57F25]/15 border border-[#F57F25]/30 text-[#F57F25] text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest mb-6">
          <i className="ri-restaurant-line"></i>
          {t('menu_page_badge')}
        </div>

        <h1 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tight leading-none mb-4">
          {t('menu_page_title')} <span className="text-[#F57F25]">{t('menu_page_title_accent')}</span>
        </h1>

        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-6">
          {t('menu_page_intro')}
        </p>

        {/* SEO keywords naturally embedded */}
        <p className="text-white/40 text-sm max-w-xl mx-auto">
          {t('menu_page_seo')}
        </p>

        {/* Scroll indicator */}
        <div className="mt-10 flex justify-center">
          <div className="w-px h-12 bg-gradient-to-b from-[#F57F25] to-transparent"></div>
        </div>
      </div>
    </section>
  );
}
